<template>
  <b-row>
    <b-col cols="4">
      <b-form-group label="Show Clear">
          <b-form-checkbox v-model="activeField.showClear" switch />
      </b-form-group>
    </b-col>
    <b-col cols="4">
      <b-form-group label="Disabled">
          <b-form-checkbox v-model="activeField.disabled" switch />
      </b-form-group>
    </b-col>
    <b-col cols="4">
      <b-form-group label="Show Score">
          <b-form-checkbox v-model="activeField.showScore" switch />
      </b-form-group>
    </b-col>
  </b-row>
</template>
<script>

export default {
  name: 'RatingAdvancedProp',
  store: ['activeField']
}

</script>
